import axios from "axios";
import authService from "./authService";
import { Cart, Currency, DesignPriceBrackets } from "../types";
const USER_API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const BASE_ROUTE = "/api/v1/pricing";

class PricingService {
  async getCartPricing(currency: Currency) {
    const result = await axios.get(
      `${USER_API_BASE_URL}${BASE_ROUTE}/cart/${currency}`,
      authService.getAuthHeader()
    );
    return result.data.data as Cart;
  }

  async getDesignPricing(designId: string, currency: Currency) {
    const result = await axios.get(
      `${USER_API_BASE_URL}${BASE_ROUTE}/design/${designId}/${currency}`,
      authService.getAuthHeader()
    );
    return result.data.data as DesignPriceBrackets;
  }
}

const instance = new PricingService();
export default instance;
